import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Text,
  Textarea,
  useColorModeValue,
} from '@chakra-ui/react';
import { Field } from 'formik';
import type React from 'react';

export interface TextAreaFieldProps {
  id?: string;
  label?: string;
  extra?: string;
  placeholder?: string;
  type?: string;
  name: string;
  error?: string;
  touched?: boolean;
  isRequired?: boolean;
  full?: boolean;
  rows?: number;
  labelFontSize?: string;
  labelMb?: string;
  isDisabled?: boolean;
  tooltipElement?: React.ReactNode;
  [x: string]: any;
}
export function TextAreaField(props: TextAreaFieldProps) {
  const {
    mb,
    id,
    label,
    extra,
    error,
    touched,
    placeholder,
    isRequired,
    name,
    type,
    full,
    rows = 5,
    labelFontSize,
    labelMb,
    isDisabled,
    tooltipElement,
    onDark,
    ...rest
  } = props;
  const [lightColor, darkColor] = onDark
    ? ['white', 'chakra-body-text']
    : ['chakra-body-text', 'white'];

  const textColorPrimary = useColorModeValue(lightColor, darkColor);
  const bgPrimary = useColorModeValue('transparent', 'navy.800');
  const borderPrimary = useColorModeValue('gray.600', 'whiteAlpha.100');
  const isError = !!(error && error.length > 0);

  return (
    <Flex
      direction="column"
      mb={mb || '0'}
      maxW={{ base: '100%', md: full ? '100%' : '560px', lg: full ? '100%' : '783px' }}
      w={{ base: '100%', md: full ? '100%' : '560px', lg: full ? '100%' : '783px' }}
    >
      <FormControl isRequired={isRequired} isInvalid={isError} isDisabled={isDisabled}>
        {!!label && (
          <HStack justifyContent="space-between">
            <FormLabel
              display="flex"
              mb={labelMb || 6}
              htmlFor={id}
              fontSize={labelFontSize || '2xl'}
              color={textColorPrimary}
              fontWeight="bold"
              lineHeight="normal"
              _hover={{ cursor: 'pointer' }}
            >
              {label}
              <Text fontSize="sm" fontWeight="normal" ms="2px">
                {extra}
              </Text>
            </FormLabel>
            {tooltipElement && tooltipElement}
          </HStack>
        )}
        <Field
          as={Textarea}
          id={id}
          placeholder={placeholder}
          name={name}
          type={type}
          color={textColorPrimary}
          outline={isError && touched && '1px solid red'}
          fontSize="xl"
          bg={bgPrimary}
          border="2px solid "
          borderColor={borderPrimary}
          p="33px"
          borderRadius="10px"
          rows={rows}
          {...rest}
          _placeholder={{ color: 'gray.600' }}
        />
        {isError && touched && <FormErrorMessage ml="10px">{error}</FormErrorMessage>}
      </FormControl>
    </Flex>
  );
}
